import type { ReactNode } from "react";

export default function FormFieldsWrapper({
  children,
}: {
  children: ReactNode;
}) {
  return <div className="space-y-5">{children}</div>;
}
